export type Preset = 'today' | '7d' | '30d' | 'all' | 'custom';

export const PRESETS: { id: Preset; label: string }[] = [
  { id: 'today', label: 'Today' },
  { id: '7d', label: 'Last 7 days' },
  { id: '30d', label: 'Last 30 days' },
  { id: 'all', label: 'All' },
  { id: 'custom', label: 'Custom' },
];

export interface Range {
  from?: string;
  to?: string;
}

const DAY = 86_400_000;

/**
 * The ISO (UTC) bounds a preset means. Days are server-time days, like the clock in the top bar, so "Today" starts at the
 * server's midnight. `to` is left open so new items show up.
 */
export function rangeFor(
  preset: Preset,
  now: number,
  custom: { from: string; to: string },
  offsetMinutes = 0,
): Range {
  const offset = offsetMinutes * 60_000;
  const serverMidnight = Math.floor((now + offset) / DAY) * DAY - offset;
  const iso = (ms: number) => new Date(ms).toISOString();
  switch (preset) {
    case 'today':
      return { from: iso(serverMidnight) };
    case '7d':
      return { from: iso(serverMidnight - 6 * DAY) };
    case '30d':
      return { from: iso(serverMidnight - 29 * DAY) };
    case 'all':
      return {};
    case 'custom': {
      const range: Range = {};
      const day = (d: string) => Date.parse(`${d}T00:00:00.000Z`) - offset;
      if (/^\d{4}-\d{2}-\d{2}$/.test(custom.from)) range.from = iso(day(custom.from));
      if (/^\d{4}-\d{2}-\d{2}$/.test(custom.to)) range.to = iso(day(custom.to) + DAY - 1);
      return range;
    }
  }
}

/** A message when a custom range makes no sense, otherwise null. */
export function rangeProblem(custom: { from: string; to: string }): string | null {
  if (custom.from && custom.to && custom.from > custom.to) return 'The start date is after the end date.';
  return null;
}
